import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const MainPage = lazy(() => import('../../container/pages/MainPage'));
// const RulePage = lazy(() => import('../../container/pages/RulePage'));
const BetPage = lazy(() => import('../../container/pages/BetPage'));
const BetReportPage = lazy(() => import('../../container/pages/BetReportPage'));
// const HeaderPage = lazy(() => import('../../container/pages/HeaderPage'));
// const AgentPage = lazy(() => import('../../container/pages/AgentPage'));
// const MemberPage = lazy(() => import('../../container/pages/MemberPage'));
const AnnoncePage = lazy(() => import('../../container/pages/AnnouncePage'));
const LottoResultPage = lazy(() => import('../../container/pages/LottoResultPage'));

function PagesRoute() {
  return (
    <Routes>
      <Route index element={<MainPage />} />
      {/* <Route path="/rule" element={<RulePage />} /> */}
      <Route path="/bet" element={<BetPage />} />
      <Route path="/bet-report" element={<BetReportPage />} />
      {/* <Route path="/header" element={<HeaderPage />} /> */}
      {/* <Route path="/agent" element={<AgentPage />} /> */}
      {/* <Route path="/member" element={<MemberPage />} /> */}
      <Route path="/announce" element={<AnnoncePage />} />
      <Route path="/lotto-result" element={<LottoResultPage />} />
    </Routes>
  );
}

export default PagesRoute;
